export const environment = {
  production: true,
  apiUrl: 'https://crm.intrust.dev/api',
  apiIOffice: 'https://ioffice.protected.vip/sso',
  apiPortFe: 'https://crm.intrust.dev',
  recaptcha: {
    siteKey: '6Lc5F8QpAAAAANXZ6kn_IwfViKw78pjMbtFs7Ito',
  },
};
